<div class="helpline">
  <div class="header">
    <div class="d-flex justify-content-between ps-4 pe-2 pt-3">
      <div>
        <img src="assets/icon/helpline.svg" alt="" class="cross-icon me-3" />
        <span class="change-text">Helpline Connect</span>
      </div>
    </div>
    <hr />
    <div class="p-3">
      <div class="sub-text ms-4 me-4">
        Are you sure want to connect with support on <b>1800-419-7852</b>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <button
            class="submit-btn cancel-btn"
            type="submit"
            (click)="cancelDial($event)"
          >
            Cancel
          </button>
        </div>
        <div class="col-6">
          <button class="submit-btn dial-btn" type="button" onclick="window.location.href='tel:18004197852'">Yes Dial</button>
        </div>
      </div>
    </div>
  </div>
</div>
